export default "__VITE_ASSET__lPE1tnp8__"